import { useState, useEffect } from "react";
import { Button, Container, Grid, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Print from "@material-ui/icons/Print";
import dayjs from "dayjs";
import { useContext } from "react";
import { useHistory } from "react-router-dom";

import { BookingContext } from "../providers/BookingProvider";

require("dayjs/locale/es");
dayjs.locale("es");

const ConfirmationPage = () => {
  const { booking, organization } = useContext(BookingContext);
  const [appointment, setAppointment] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const { removeLocalStorageValues } = useContext(BookingContext);

  useEffect(() => {
    setIsLoading(true);
    setAppointment(booking);
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ConfirmationDescription = ({ children, style }) => {
    return (
      <Typography
        style={{
          padding: "6px 0",
          fontSize: "18px",
          fontWeight: "900",
          color: "#4e5c94",
          ...style,
        }}
      >
        {children}
      </Typography>
    );
  };

  const ConfirmationValue = ({ children }) => {
    return (
      <Typography
        style={{
          padding: "6px 0",
          fontSize: "14px",
          color: "#6A6D81",
          float: "right",
        }}
        variant={"body2"}
      >
        {children}
      </Typography>
    );
  };

  const formatName = (customer) => {
    return customer.name + " " + customer.lastname;
  };

  const printAppointment = () => {
    window.print();
  };

  const finishProcess = () => {
    removeLocalStorageValues();
    history.push("/" + organization.nameUrl);
  };

  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: "#F0F2F9", paddingTop: 60, height: "100vh" }}
    >
      <Container>
        <Grid
          container
          spacing={3}
          style={{
            borderRadius: 16,
            backgroundColor: "#FFF",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            padding: "3rem",
            color: "#4E5C93",
          }}
        >
          {!isLoading ? (
            <>
              {/* appointment and payment confirmation message */}
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#daf4d5",
                  borderRadius: "8px",
                  padding: "1rem",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  marginBottom: "2em",
                }}
              >
                <CheckCircleIcon
                  style={{
                    float: "left",
                    fontSize: "2em",
                    marginRight: "0.60em",
                    color: "#29b92f",
                  }}
                />{" "}
                <Typography
                  variant={"h6"}
                  style={{ color: "#536296", fontWeight: "bold" }}
                >
                  Tu reserva ha sido completada con exíto!
                </Typography>
              </Grid>

              {/* appointment details */}
              <Grid container item xs={12} sm={6} style={{ paddingLeft: 0 }}>
                {/* appointment information resume */}
                <Grid
                  container
                  style={{
                    backgroundColor: "#fffafa",
                    borderRadius: "4px",
                    padding: "1em 4em 1em 2em",
                  }}
                >
                  <Grid container item xs={12}>
                    <Grid item xs={12} md={6}>
                      <ConfirmationDescription>
                        Test solicitado:
                      </ConfirmationDescription>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ConfirmationValue>
                        {appointment?.product?.name}
                      </ConfirmationValue>
                      <ConfirmationValue>
                        {appointment?.product?.serviceName}
                      </ConfirmationValue>
                    </Grid>
                  </Grid>
                  <Grid container item>
                    <Grid item xs={12} md={6}>
                      <ConfirmationDescription>Día:</ConfirmationDescription>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ConfirmationValue>{appointment?.date}</ConfirmationValue>
                    </Grid>
                  </Grid>
                  <Grid container item>
                    <Grid item xs={12} md={6}>
                      <ConfirmationDescription>
                        Franja horaria:
                      </ConfirmationDescription>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ConfirmationValue>
                        {appointment?.time?.label}
                      </ConfirmationValue>
                    </Grid>
                  </Grid>
                  <Grid container item>
                    <Grid item xs={12} md={6}>
                      <ConfirmationDescription>Comuna:</ConfirmationDescription>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ConfirmationValue>
                        {appointment?.location?.name}
                      </ConfirmationValue>
                    </Grid>
                  </Grid>
                  {appointment?.patients &&
                    appointment.patients.map((patient, i) => (
                      <Grid item xs={12} key={i}>
                        <Grid container item>
                          <Grid item xs={12} md={6}>
                            <ConfirmationDescription>
                              Paciente 0{i + 1}:
                            </ConfirmationDescription>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <ConfirmationValue>
                              {formatName(patient)}
                            </ConfirmationValue>
                          </Grid>
                        </Grid>
                        <Grid container item>
                          <Grid item xs={12} md={6}>
                            <ConfirmationDescription>
                              Dirección:
                            </ConfirmationDescription>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <ConfirmationValue>
                              {patient.street}
                            </ConfirmationValue>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                </Grid>
              </Grid>

              {/* number of appointmnet and print appointment bill */}
              <Grid container xs={12} sm={6}>
                <Grid
                  container
                  // item
                  style={{
                    padding: "1em",
                    paddingLeft: "3em",
                    textAlign: "left",
                    paddingTop: "0",
                  }}
                >
                  {/* appointment number */}
                  <Grid
                    container
                    // item
                    style={{ marginTop: 0 }}
                    spacing={2}
                  >
                    <Grid
                      item
                      // xs={11}
                      xs={12}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <p>N* de reserva:</p>
                      <b>{appointment?.id}</b>
                    </Grid>
                  </Grid>

                  {/* print appointment details */}
                  <Grid
                    container
                    spacing={2}
                    // item
                    style={{ marginTop: "1.5em", cursor: "pointer" }}
                    onClick={printAppointment}
                  >
                    <Grid
                      item
                      xs={1}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Print
                        style={{
                          float: "left",
                          fontSize: "1.7em",
                          color: "#6A6D81",
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#333333",
                          fontSize: "13px",
                          fontWeight: "900",
                        }}
                      >
                        Imprimir recibo
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Button
                variant={"contained"}
                color={"primary"}
                // style={{ float: "right" }}
                onClick={finishProcess}
                disabled={!booking.location || !booking.date || !booking.time}
              >
                Finalizar
              </Button>
            </>
          ) : (
            <p>Cargando...</p>
          )}
        </Grid>
      </Container>
    </Container>
  );
};

export default ConfirmationPage;
